import { Component, type ErrorInfo, type ReactNode } from 'react'
import { tracker } from '../services/tracking'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

/**
 * Catches unhandled React render errors and reports them to the tracker.
 * Wrap around route-level components in App.tsx.
 */
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    tracker.error(error, {
      componentStack: info.componentStack ?? undefined,
      source: 'ErrorBoundary',
    })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div dir="rtl" style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>حدث خطأ غير متوقع</h2>
          <p>يرجى تحديث الصفحة أو المحاولة لاحقاً</p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              cursor: 'pointer',
            }}
          >
            حاول مرة أخرى
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
